
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./MiniGame": function() {
return Promise.all([__webpack_require__.e("777"), __webpack_require__.e("942"), __webpack_require__.e("513"), __webpack_require__.e("622"), __webpack_require__.e("39")]).then(function() { return function() { return __webpack_require__(9998); }; });
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };